<!-- TVG-342: extra email addresses. Adding the address a Not filed reply came
     from files it on this contact, and later email from it files itself. -->
<div class="mb-3 rounded-2xl w-full border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]" data-testid="contact-email-addresses">
  <div class="px-5 py-4 sm:px-6 sm:py-5">
    <h3 class="text-base font-medium text-gray-800 dark:text-white/90">Extra email addresses</h3>
    <p class="mt-1 text-theme-sm text-gray-500 dark:text-gray-400">
      Email from these addresses is filed on this contact, as well as email from their main address.
    </p>
  </div>

  <div class="space-y-3 border-t border-gray-100 p-5 dark:border-gray-800 sm:p-6">
    @if (notice) {
      <div class="rounded-lg border border-green-200 bg-green-50/70 px-3 py-2 text-theme-sm text-green-700 dark:border-green-500/30 dark:bg-green-500/10 dark:text-green-300" data-testid="contact-email-addresses-notice">
        {{ notice }}
      </div>
    }

    @if (error) {
      <div class="rounded-md bg-error-50 p-3 text-theme-sm text-error-700">{{ error }}</div>
    }

    @if (addresses.length > 0) {
      <ul class="divide-y divide-gray-100 rounded-xl border border-gray-200 dark:divide-gray-800 dark:border-gray-800">
        @for (address of addresses; track address.id) {
          <li class="flex items-center justify-between px-4 py-2.5 text-theme-sm text-gray-700 dark:text-gray-300">
            <span>{{ address.email }}</span>
            @if (canEdit) {
              <button
                type="button"
                class="text-theme-xs font-medium text-gray-500 hover:text-error-600 dark:text-gray-400"
                (click)="remove(address)">
                Remove
              </button>
            }
          </li>
        }
      </ul>
    } @else if (!loading) {
      <p class="text-theme-sm text-gray-500 dark:text-gray-400">No extra email addresses.</p>
    }

    @if (canEdit) {
      <div class="flex flex-wrap items-end gap-2">
        <div class="min-w-[16rem] flex-1">
          <app-text-input
            [control]="emailControl"
            [type]="'email'"
            [name]="'extra_email'"
            [placeholder]="'another@example.com'"
            [label]="'Add an email address'"
          ></app-text-input>
        </div>
        <app-button
          [type]="'button'"
          [style]="'secondary'"
          [label]="saving ? 'Adding…' : 'Add'"
          [disabled]="saving"
          data-testid="contact-email-addresses-add"
          (click)="add()"
        ></app-button>
      </div>
    }
  </div>
</div>
